import { render, staticRenderFns } from "./categoryTabPanel.vue?vue&type=template&id=d7fb0b16&"
import script from "./categoryTabPanel.vue?vue&type=script&lang=js&"
export * from "./categoryTabPanel.vue?vue&type=script&lang=js&"
import style0 from "./categoryTabPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports